<template>
  <vx-card>
    <vs-tabs v-model="abaAtiva" class="tabs-shadow-none">
    <vs-tab label="Parâmetros Predefinidos">
    <vs-row vs-w="12">
      <vs-col vs-w="11">
        <h4 style="color: #b4aa99">Parâmetros Predefinidos</h4>
      </vs-col>
      <vs-col vs-align="center" vs-justify="flex-end" vs-type="flex" vs-w="1">
        <vs-button
            :disabled="!$atividades.permissoes.includes(14) || blockButton"
            color="success"
            size="small"
            type="relief"
            @click="update"
        >Atualizar
        </vs-button
        >
      </vs-col>
    </vs-row>
    <VuePerfectScrollbar
        :settings="settings"
        class="scroll-parametros"
        style="background-color: transparent"
    >
      <div id="parametros" class="mt-10 vs-con-loading__container">
        <vs-divider border-style="dotted" class="font-bold" color="dark"
        >Configuração Comercial
        </vs-divider
        >
        <vs-row
            vs-align="center"
            vs-justify="flex-start"
            vs-type="flex"
            vs-w="12"
        >
          <vs-col
              class="mb-3"
              vs-align="center"
              vs-justify="flex-start"
              vs-type="flex"
              vs-w="2.4"
          >
            <vs-input
                v-model="parametro.validade_proposta"
                class="mx-4 w-full"
                color="dark"
                icon="DIAS"
                icon-after="true"
                label-placeholder="Validade da Proposta"
                min="0"
                type="number"
            />
          </vs-col>
          <vs-col
              class="mb-3"
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="2.4"
          >
            <vs-input
                v-model="parametro.dias_servico_complementar"
                class="w-full mx-4"
                color="dark"
                icon="DIAS"
                icon-after="true"
                label-placeholder="Serviço Complementar"
                min="0"
                type="number"
            />
          </vs-col>
          <vs-col
              class="mb-3"
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="2.4"
          >
            <vs-input
                v-model="parametro.carros_empresa"
                class="w-full mx-4"
                color="dark"
                icon="QTD"
                icon-after="true"
                label-placeholder="Carros da Empresa"
                min="0"
                type="number"
            />
          </vs-col>
          <vs-col class="mb-3" vs-w="2">
            <vs-checkbox
                v-model="parametro.usarHorario13ParaTurnoTarde"
                class="w-full mx-4 pt-6"
                color="success"
            >Horario das 13 no turno da tarde
            </vs-checkbox
            >
          </vs-col>
        </vs-row>
        <vs-divider border-style="dotted" class="font-bold" color="dark"
        >Configuração Financeiro
        </vs-divider
        >
        <vs-row vs-type="flex" vs-w="12">
          <vs-col
              class="mb-3"
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="2.4"
          >
            <vs-input
                v-model="parametro.inss"
                class="mx-4 w-full"
                color="dark"
                icon="%"
                icon-after="true"
                label-placeholder="INSS"
                min="0"
                type="text"
            />
          </vs-col>
          <vs-col
              class="mb-3"
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="2.4"
          >
            <vs-input
                v-model="parametro.iss"
                class="mx-4 w-full"
                color="dark"
                icon="%"
                icon-after="true"
                label-placeholder="ISS"
                min="0"
                type="text"
            />
          </vs-col>
          <vs-col
              class="mb-3"
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="2.4"
          >
            <vs-input
                v-model="parametro.dias_cobranca"
                class="w-full mx-4"
                color="dark"
                icon="DIAS"
                icon-after="true"
                label-placeholder="Cobrança"
                min="0"
                type="number"
            />
          </vs-col>
          <vs-col class="mb-3" vs-w="2">
            <vs-checkbox
                v-model="parametro.auto_boleto"
                class="w-full mx-4 pt-6"
                color="success"
            >Boleto Automático
            </vs-checkbox
            >
          </vs-col>
          <vs-col class="mb-3" vs-w="2">
            <vs-checkbox
                v-model="parametro.auto_nota"
                class="w-full mx-4 pt-6"
                color="success"
            >Nota Automática
            </vs-checkbox>
          </vs-col>
          <vs-col class="mb-3" vs-w="3.5">
            <vs-checkbox
                v-model="parametro.enviar_wati_abertura_chamado"
                class="w-full mx-4 pt-6"
                color="success"
            >Disparo automático WATI Abertura Chamado
            </vs-checkbox>
          </vs-col>
        </vs-row>
        <vs-row
            vs-align="center"
            vs-justify="flex-start"
            vs-type="flex"
            vs-w="12"
        >
          <vs-col vs-w="12">
            <span class="text-grey mx-4">Alíquotas Aproximadas (Lei da Transparência / IBPT)</span>
          </vs-col>
          <vs-col
              class="mb-3"
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="2.4"
          >
            <vs-input
                v-model="parametro.ibpt_federal"
                class="mx-4 w-full"
                color="dark"
                icon="%"
                icon-after="true"
                label-placeholder="IBPT Federal"
                min="0"
                type="text"
            />
          </vs-col>
          <vs-col
              class="mb-3"
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="2.4"
          >
            <vs-input
                v-model="parametro.ibpt_estadual"
                class="mx-4 w-full"
                color="dark"
                icon="%"
                icon-after="true"
                label-placeholder="IBPT Estadual"
                min="0"
                type="text"
            />
          </vs-col>
          <vs-col
              class="mb-3"
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="2.4"
          >
            <vs-input
                v-model="parametro.ibpt_municipal"
                class="mx-4 w-full"
                color="dark"
                icon="%"
                icon-after="true"
                label-placeholder="IBPT Municipal"
                min="0"
                type="text"
            />
          </vs-col>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12">
          <vs-col
              class="mb-3"
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="3"
          >
            <div class="w-full">
              <vs-col
                  class="mb-3"
                  vs-align="center"
                  vs-justify="center"
                  vs-type="flex"
                  vs-w="12"
              >
                <vs-input
                    v-model="parametro.email_faturamento"
                    class="w-full mx-4"
                    color="dark"
                    label-placeholder="Email Faturamento"
                    type="email"
                />
              </vs-col>
              <vs-col
                  class="mb-3"
                  vs-align="center"
                  vs-justify="center"
                  vs-type="flex"
                  vs-w="12"
              >
                <vs-input
                    v-model="parametro.password_faturamento"
                    class="w-full mx-4"
                    color="dark"
                    label-placeholder="Senha"
                    type="password"
                />
              </vs-col>
              <vs-col
                  class="mb-3"
                  vs-align="center"
                  vs-justify="center"
                  vs-type="flex"
                  vs-w="12"
              >
                <vs-input
                    v-model="parametro.email_faturamento_contato"
                    class="w-full mx-4"
                    color="dark"
                    label-placeholder="Email Corpo Email"
                    type="text"
                />
              </vs-col>
              <vs-col
                  class="mb-3"
                  vs-align="center"
                  vs-justify="center"
                  vs-type="flex"
                  vs-w="12"
              >
                <vs-input
                    v-model="parametro.telefone_faturamento_contato"
                    class="w-full mx-4"
                    color="dark"
                    label-placeholder="Telefone Corpo Email"
                    type="text"
                />
              </vs-col>
            </div>
          </vs-col>
          <vs-col
              class="mb-3"
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="3"
          >
            <div class="w-full">
              <vs-col
                  class="mb-3"
                  vs-align="center"
                  vs-justify="center"
                  vs-type="flex"
                  vs-w="12"
              >
                <vs-input
                    v-model="parametro.email_cobranca"
                    class="w-full mx-4"
                    color="dark"
                    label-placeholder="Email Cobrança"
                    type="email"
                />
              </vs-col>
              <vs-col
                  class="mb-3"
                  vs-align="center"
                  vs-justify="center"
                  vs-type="flex"
                  vs-w="12"
              >
                <vs-input
                    v-model="parametro.password_cobranca"
                    class="w-full mx-4"
                    color="dark"
                    label-placeholder="Senha"
                    type="password"
                />
              </vs-col>
              <vs-col
                  class="mb-3"
                  vs-align="center"
                  vs-justify="center"
                  vs-type="flex"
                  vs-w="12"
              >
                <vs-input
                    v-model="parametro.email_cobranca_contato"
                    class="w-full mx-4"
                    color="dark"
                    label-placeholder="Email Corpo Email"
                    type="text"
                />
              </vs-col>
              <vs-col
                  class="mb-3"
                  vs-align="center"
                  vs-justify="center"
                  vs-type="flex"
                  vs-w="12"
              >
                <vs-input
                    v-model="parametro.telefone_cobranca_contato"
                    class="w-full mx-4"
                    color="dark"
                    label-placeholder="Telefone Corpo Email"
                    type="text"
                />
              </vs-col>
            </div>
          </vs-col>
          <vs-col
              class="mb-3"
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="3"
          >
            <div class="w-full">
              <vs-col
                  class="mb-3"
                  vs-align="center"
                  vs-justify="center"
                  vs-type="flex"
                  vs-w="12"
              >
                <vs-input
                    v-model="parametro.email_lembrete_vencimento"
                    class="w-full mx-4"
                    color="dark"
                    label-placeholder="Email Lembrete Vencimento"
                    type="email"
                />
              </vs-col>
              <vs-col
                  class="mb-3"
                  vs-align="center"
                  vs-justify="center"
                  vs-type="flex"
                  vs-w="12"
              >
                <vs-input
                    v-model="parametro.password_lembrete_vencimento"
                    class="w-full mx-4"
                    color="dark"
                    label-placeholder="Senha"
                    type="password"
                />
              </vs-col>
              <vs-col
                  class="mb-3"
                  vs-align="center"
                  vs-justify="center"
                  vs-type="flex"
                  vs-w="12"
              >
                <vs-input
                    v-model="parametro.email_lembrete_vencimento_contato"
                    class="w-full mx-4"
                    color="dark"
                    label-placeholder="Email Corpo Email"
                    type="text"
                />
              </vs-col>
              <vs-col
                  class="mb-3"
                  vs-align="center"
                  vs-justify="center"
                  vs-type="flex"
                  vs-w="12"
              >
                <vs-input
                    v-model="parametro.telefone_lembrete_vencimento_contato"
                    class="w-full mx-4"
                    color="dark"
                    label-placeholder="Telefone Corpo Email"
                    type="text"
                />
              </vs-col>
            </div>
          </vs-col>
        </vs-row>
        <vs-divider border-style="dotted" class="font-bold" color="dark"
        >Configuração WhatsApp
        </vs-divider
        >
        <vs-row vs-type="flex" vs-w="12" class="mb-4">
          <vs-col class="mb-3 px-4" vs-w="3">
            <label class="vs-input--label">Provedor WhatsApp</label>
            <vs-select
                v-model="parametro.provedor_whatsapp"
                class="w-full"
                name="provedor_whatsapp"
                placeholder="Selecione o provedor"
            >
              <vs-select-item
                  v-for="item in provedoresWhatsapp"
                  :key="item.value"
                  :text="item.text"
                  :value="item.value"
              />
            </vs-select>
          </vs-col>
        </vs-row>

        <div class="mb-3 px-4 flex flex-wrap items-center justify-between" style="gap: 12px;">
          <div class="flex-1" style="min-width: 280px;">
            <p class="text-xs mb-0" style="color: #334155; line-height: 1.5;">
              Templates aprovados no WATI para disparo automatizado. Clique nos templates selecionados abaixo para inspecionar as <strong style="color: #0f172a;">variáveis, campos de envio e gravação no banco de dados via Webhook</strong>.
            </p>
          </div>
          <div>
            <button
              type="button"
              class="btn-inspecionar-wati-a11y"
              aria-label="Inspecionar Variáveis e Tabelas SQL dos Templates WATI"
              @click="abrirModalDetalhesTemplate(null, 'confirmacao')"
            >
              <svg
                class="btn-icon-svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.2"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
              >
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
              </svg>
              <span>Inspecionar Variáveis &amp; Tabelas SQL</span>
            </button>
          </div>
        </div>

        <vs-row vs-type="flex" vs-w="12" class="mb-3">
          <vs-col class="mb-4 px-4" vs-w="6">
            <div class="flex items-center justify-between flex-wrap mb-1" style="min-height: 28px; gap: 8px;">
              <label class="vs-input--label font-semibold mb-0 mr-2" style="color: #0f172a;">Templates WATI — Confirmação de OS</label>
              <div v-if="templatesConfirmacaoOs && templatesConfirmacaoOs.length" class="flex flex-wrap items-center" style="gap: 5px;">
                <span class="text-xs font-semibold mr-1 select-none" style="color: #334155; line-height: 1;">Inspecionar:</span>
                <button
                  v-for="tplNome in templatesConfirmacaoOs"
                  :key="tplNome"
                  type="button"
                  class="badge-inspecao-a11y badge-inspecao-os"
                  :aria-label="'Inspecionar template de Confirmação de OS ' + tplNome"
                  @click="abrirModalDetalhesTemplate(tplNome, 'confirmacao')"
                >
                  <svg
                    class="badge-icon-svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    aria-hidden="true"
                  >
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                  <span>{{ tplNome }}</span>
                </button>
              </div>
            </div>
            <p class="text-xs mb-1" style="color: #475569; font-weight: 500;">Templates exibidos no modal de Confirmação de OS (ex: pco_confirmacao_nova1, confirmacao_ultima_chamada)</p>
            <el-select
              v-model="templatesConfirmacaoOs"
              multiple
              filterable
              allow-create
              default-first-option
              class="w-full"
              placeholder="Selecione ou digite os templates de Confirmação de OS"
            >
              <el-option
                v-for="tpl in listaTemplatesWati"
                :key="tpl.elementName || tpl"
                :label="tpl.elementName || tpl"
                :value="tpl.elementName || tpl"
              />
            </el-select>
          </vs-col>

          <vs-col class="mb-4 px-4" vs-w="6">
            <div class="flex items-center justify-between flex-wrap mb-1" style="min-height: 28px; gap: 8px;">
              <label class="vs-input--label font-semibold mb-0 mr-2" style="color: #0f172a;">Templates WATI — PCO (Confirmação Prévia)</label>
              <div v-if="templatesPco && templatesPco.length" class="flex flex-wrap items-center" style="gap: 5px;">
                <span class="text-xs font-semibold mr-1 select-none" style="color: #334155; line-height: 1;">Inspecionar:</span>
                <button
                  v-for="tplNome in templatesPco"
                  :key="tplNome"
                  type="button"
                  class="badge-inspecao-a11y badge-inspecao-pco"
                  :aria-label="'Inspecionar template PCO ' + tplNome"
                  @click="abrirModalDetalhesTemplate(tplNome, 'confirmacao')"
                >
                  <svg
                    class="badge-icon-svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    aria-hidden="true"
                  >
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                  <span>{{ tplNome }}</span>
                </button>
              </div>
            </div>
            <p class="text-xs mb-1" style="color: #475569; font-weight: 500;">Templates específicos para PCO</p>
            <el-select
              v-model="templatesPco"
              multiple
              filterable
              allow-create
              default-first-option
              class="w-full"
              placeholder="Selecione ou digite os templates de PCO"
            >
              <el-option
                v-for="tpl in listaTemplatesWati"
                :key="tpl.elementName || tpl"
                :label="tpl.elementName || tpl"
                :value="tpl.elementName || tpl"
              />
            </el-select>
          </vs-col>
        </vs-row>

        <vs-row vs-type="flex" vs-w="12" class="mb-4">
          <vs-col class="mb-4 px-4" vs-w="6">
            <div class="flex items-center justify-between flex-wrap mb-1" style="min-height: 28px; gap: 8px;">
              <label class="vs-input--label font-semibold mb-0 mr-2" style="color: #0f172a;">Templates WATI — Pós-Venda</label>
              <div v-if="templatesPosVenda && templatesPosVenda.length" class="flex flex-wrap items-center" style="gap: 5px;">
                <span class="text-xs font-semibold mr-1 select-none" style="color: #334155; line-height: 1;">Inspecionar:</span>
                <button
                  v-for="tplNome in templatesPosVenda"
                  :key="tplNome"
                  type="button"
                  class="badge-inspecao-a11y badge-inspecao-pos-venda"
                  :aria-label="'Inspecionar template de Pós-Venda ' + tplNome"
                  @click="abrirModalDetalhesTemplate(tplNome, 'pos_venda')"
                >
                  <svg
                    class="badge-icon-svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    aria-hidden="true"
                  >
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                  <span>{{ tplNome }}</span>
                </button>
              </div>
            </div>
            <p class="text-xs mb-1" style="color: #475569; font-weight: 500;">Templates exibidos no modal da tela de Pós-Venda</p>
            <el-select
              v-model="templatesPosVenda"
              multiple
              filterable
              allow-create
              default-first-option
              class="w-full"
              placeholder="Selecione ou digite os templates de Pós-Venda"
            >
              <el-option
                v-for="tpl in listaTemplatesWati"
                :key="tpl.elementName || tpl"
                :label="tpl.elementName || tpl"
                :value="tpl.elementName || tpl"
              />
            </el-select>
          </vs-col>

          <vs-col class="mb-4 px-4" vs-w="6">
            <div class="flex items-center justify-between flex-wrap mb-1" style="min-height: 28px; gap: 8px;">
              <label class="vs-input--label font-semibold mb-0 mr-2" style="color: #0f172a;">Templates WATI — Cobrança</label>
              <div v-if="templatesCobranca && templatesCobranca.length" class="flex flex-wrap items-center" style="gap: 5px;">
                <span class="text-xs font-semibold mr-1 select-none" style="color: #334155; line-height: 1;">Inspecionar:</span>
                <button
                  v-for="tplNome in templatesCobranca"
                  :key="tplNome"
                  type="button"
                  class="badge-inspecao-a11y badge-inspecao-cobranca"
                  :aria-label="'Inspecionar template de Cobrança ' + tplNome"
                  @click="abrirModalDetalhesTemplate(tplNome, 'cobranca')"
                >
                  <svg
                    class="badge-icon-svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    aria-hidden="true"
                  >
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                  <span>{{ tplNome }}</span>
                </button>
              </div>
            </div>
            <p class="text-xs mb-1" style="color: #475569; font-weight: 500;">Templates exibidos no financeiro / cobrança</p>
            <el-select
              v-model="templatesCobranca"
              multiple
              filterable
              allow-create
              default-first-option
              class="w-full"
              placeholder="Selecione ou digite os templates de Cobrança"
            >
              <el-option
                v-for="tpl in listaTemplatesWati"
                :key="tpl.elementName || tpl"
                :label="tpl.elementName || tpl"
                :value="tpl.elementName || tpl"
              />
            </el-select>
          </vs-col>
        </vs-row>
        <vs-divider border-style="dotted" class="font-bold" color="dark"
        >Configuração Processual
        </vs-divider
        >
        <vs-row
            vs-align="flex-start"
            vs-justify="flex-start"
            vs-type="flex"
            vs-w="12"
        >
          <vs-col
              class="mb-3"
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="3"
          >
            <vs-input
                v-model="parametro.tecnico_responsavel"
                class="w-full mx-4"
                color="dark"
                label-placeholder="Técnico Responsável"
                type="text"
            />
          </vs-col>
          <vs-col
              class="mb-3"
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="3"
          >
            <vs-input
                v-model="parametro.enginheiro_quimico"
                class="w-full mx-4"
                color="dark"
                label-placeholder="Engenheiro Químico"
                type="text"
            />
          </vs-col>
          <vs-col
              class="mb-3"
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="3"
          >
            <vs-input
                v-model="parametro.telefone_de_emergencia"
                v-mask="getPhoneMask(parametro.telefone_de_emergencia)"
                :maxlength="15"
                type="tel"
                class="w-full mx-4"
                color="dark"
                label-placeholder="Telefone de Emergência"
            />
          </vs-col>
          <vs-col
              class="mb-3"
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="3"
          >
            <vs-checkbox
                v-model="parametro.impressao_certificado"
                class="w-full mx-4 mt-6"
                color="success"
            >Certificado Pré-Impresso
            </vs-checkbox
            >
          </vs-col>
          <vs-col
              class="mb-3"
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="3"
          >
            <div class="w-full">
              <vs-col
                  class="mb-3"
                  vs-align="center"
                  vs-justify="center"
                  vs-type="flex"
                  vs-w="12"
              >
                <vs-input
                    v-model="parametro.assinatura_relatorio"
                    class="w-full mx-4"
                    color="dark"
                    label-placeholder="Assinatura Relatório"
                    type="text"
                />
              </vs-col>
              <vs-col
                  class="mb-3"
                  vs-align="center"
                  vs-justify="center"
                  vs-type="flex"
                  vs-w="12"
              >
                <vs-input
                    v-model="parametro.assinatura_certificado"
                    class="w-full mx-4"
                    color="dark"
                    label-placeholder="Assinatura Certificado"
                    type="text"
                />
              </vs-col>
              <vs-col
                  class="mb-3"
                  vs-align="center"
                  vs-justify="center"
                  vs-type="flex"
                  vs-w="12"
              >
                <vs-input
                    v-model="parametro.numero_registro"
                    class="w-full mx-4"
                    color="dark"
                    label-placeholder="Número Registro (RNP)"
                    type="text"
                />
              </vs-col>
              <vs-col
                  class="mb-3"
                  vs-align="center"
                  vs-justify="center"
                  vs-type="flex"
                  vs-w="12"
              >
                <vs-input
                    v-model="parametro.telefone_de_emergencia_2"
                    class="w-full mx-4"
                    color="dark"
                    label-placeholder="Telefone de Emergência CIT"
                    type="text"
                />
              </vs-col>
              <vs-col
                  class="mb-3"
                  vs-align="center"
                  vs-justify="center"
                  vs-type="flex"
                  vs-w="12"
              >
                <vs-input
                    v-model="parametro.telefone_de_emergencia_3"
                    class="w-full mx-4"
                    color="dark"
                    label-placeholder="Telefone de Emergência SAMU"
                    type="text"
                />
              </vs-col>
            </div>
          </vs-col>
          <vs-col
              class="mb-3"
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="3"
          >
            <div class="w-full">
              <vs-col
                  class="mb-3"
                  vs-align="center"
                  vs-justify="center"
                  vs-type="flex"
                  vs-w="12"
              >
                <vs-input
                    v-model="parametro.email_confirmacao_servico"
                    class="w-full mx-4"
                    color="dark"
                    label-placeholder="Email Confirmação de Serviços"
                    type="email"
                />
              </vs-col>
              <vs-col
                  class="mb-3"
                  vs-align="center"
                  vs-justify="center"
                  vs-type="flex"
                  vs-w="12"
              >
                <vs-input
                    v-model="parametro.password_confirmacao_servico"
                    class="w-full mx-4"
                    color="dark"
                    label-placeholder="Senha"
                    type="password"
                />
              </vs-col>
              <vs-col
                  class="mb-3"
                  vs-align="center"
                  vs-justify="center"
                  vs-type="flex"
                  vs-w="12"
              >
                <vs-input
                    v-model="parametro.email_confirmacao_servico_contato"
                    class="w-full mx-4"
                    color="dark"
                    label-placeholder="Email Corpo Email"
                    type="text"
                />
              </vs-col>
              <vs-col
                  class="mb-3"
                  vs-align="center"
                  vs-justify="center"
                  vs-type="flex"
                  vs-w="12"
              >
                <vs-input
                    v-model="parametro.telefone_confirmacao_servico_contato"
                    class="w-full mx-4"
                    color="dark"
                    label-placeholder="Telefone Corpo Email"
                    type="text"
                />
              </vs-col>
              <vs-col
                  class="mb-3"
                  vs-align="center"
                  vs-justify="center"
                  vs-type="flex"
                  vs-w="12"
              >
                <vs-input
                    v-model="parametro.link_avaliacao"
                    class="w-full mx-4"
                    color="dark"
                    label-placeholder="Link de Avaliação"
                    type="text"
                />
              </vs-col>
            </div>
          </vs-col>
          <vs-col
              class="mb-3"
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="3"
          >
            <div class="w-full">
              <vs-col
                  class="mb-3"
                  vs-align="center"
                  vs-justify="center"
                  vs-type="flex"
                  vs-w="12"
              >
                <vs-input
                    v-model="parametro.email_rel_tecnico"
                    class="w-full mx-4"
                    color="dark"
                    label-placeholder="Email Relatório Técnico"
                    type="email"
                />
              </vs-col>
              <vs-col
                  class="mb-3"
                  vs-align="center"
                  vs-justify="center"
                  vs-type="flex"
                  vs-w="12"
              >
                <vs-input
                    v-model="parametro.password_rel_tecnico"
                    class="w-full mx-4"
                    color="dark"
                    label-placeholder="Senha"
                    type="password"
                />
              </vs-col>
              <vs-col
                  class="mb-3"
                  vs-align="center"
                  vs-justify="center"
                  vs-type="flex"
                  vs-w="12"
              >
                <vs-input
                    v-model="parametro.email_rel_tecnico_contato"
                    class="w-full mx-4"
                    color="dark"
                    label-placeholder="Email Corpo Email"
                    type="text"
                />
              </vs-col>
              <vs-col
                  class="mb-3"
                  vs-align="center"
                  vs-justify="center"
                  vs-type="flex"
                  vs-w="12"
              >
                <vs-input
                    v-model="parametro.telefone_rel_tecnico_contato"
                    class="w-full mx-4"
                    color="dark"
                    label-placeholder="Telefone Corpo Email"
                    type="text"
                />
              </vs-col>
            </div>
          </vs-col>
          <vs-col
              class="mb-3"
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="3"
          >
            <div class="w-full">
              <vs-col
                  class="mb-3"
                  vs-align="center"
                  vs-justify="center"
                  vs-type="flex"
                  vs-w="12"
              >
                <vs-input
                    v-model="parametro.storage_url"
                    class="w-full mx-4"
                    color="dark"
                    label-placeholder="Local do Servidor para Upload"
                    type="email"
                />
              </vs-col>
              <vs-col
                  class="mb-3"
                  vs-align="center"
                  vs-justify="center"
                  vs-type="flex"
                  vs-w="12"
              >
                <vs-input
                    v-model="parametro.storage_cdn_url"
                    class="w-full mx-4"
                    color="dark"
                    label-placeholder="Local do Servidor para Visualização"
                    type="text"
                />
              </vs-col>
              <vs-col
                  class="mb-3"
                  vs-align="center"
                  vs-justify="center"
                  vs-type="flex"
                  vs-w="12"
              >
                <vs-input
                    v-model="parametro.relatorio_cod_dvisa"
                    class="w-full mx-4"
                    color="dark"
                    label-placeholder="Código DVISA"
                    type="text"
                />
              </vs-col>
            </div>
          </vs-col>
        </vs-row>
        <vs-row
            vs-align="flex-start"
            vs-justify="flex-start"
            vs-type="flex"
            vs-w="12"
        >
          <vs-col
              class="mb-3"
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="2"
          >
            <vs-input
                v-model="parametro.comissao_1_estrela"
                class="w-full mx-4"
                color="dark"
                icon="DIAS"
                icon-after="true"
                label-placeholder="Premiação 1 Estrela"
                type="text"
            />
          </vs-col>
          <vs-col
              class="mb-3"
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="2"
          >
            <vs-input
                v-model="parametro.comissao_2_estrela"
                class="w-full mx-4"
                color="dark"
                icon="R$"
                icon-after="true"
                label-placeholder="Premiação 2 estrelas"
                type="text"
            />
          </vs-col>
          <vs-col
              class="mb-3"
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="2"
          >
            <vs-input
                v-model="parametro.comissao_3_estrela"
                class="w-full mx-4"
                color="dark"
                icon="R$"
                icon-after="true"
                label-placeholder="Premiação 3 estrelas"
                type="text"
            />
          </vs-col>
          <vs-col
              class="mb-3"
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="2"
          >
            <vs-input
                v-model="parametro.comissao_4_estrela"
                class="w-full mx-4"
                color="dark"
                icon="R$"
                icon-after="true"
                label-placeholder="Premiação 4 estrelas"
                type="text"
            />
          </vs-col>
          <vs-col
              class="mb-3"
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="2"
          >
            <vs-input
                v-model="parametro.comissao_5_estrela"
                class="w-full mx-4"
                color="dark"
                icon="R$"
                icon-after="true"
                label-placeholder="Premiação 5 estrelas"
                type="text"
            />
          </vs-col>
          <vs-col
              class="mb-3"
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="2"
          >
            <vs-input
                v-model="parametro.comissao_nao_avaliado"
                class="w-full mx-4"
                color="dark"
                icon="R$"
                icon-after="true"
                label-placeholder="Premiação não avaliada"
                type="text"
            />
          </vs-col>
        </vs-row>

        <vs-row vs-align="center" vs-justify="center" vs-type="flex" vs-w="12">
          <vs-col
              class="mb-3"
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="2"
          >
            <vs-input
                v-model="parametro.carros_manha"
                class="w-full mx-4"
                color="dark"
                icon="QTD"
                icon-after="true"
                label-placeholder="Carros manha"
                type="text"
            />
          </vs-col>
          <vs-col
              class="mb-3"
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="2"
          >
            <vs-input
                v-model="parametro.carros_almoco"
                class="w-full mx-4"
                color="dark"
                icon="QTD"
                icon-after="true"
                label-placeholder="Carros almoco"
                type="text"
            />
          </vs-col>
          <vs-col
              class="mb-3"
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="2"
          >
            <vs-input
                v-model="parametro.carros_tarde"
                class="w-full mx-4"
                color="dark"
                icon="QTD"
                icon-after="true"
                label-placeholder="Carros tarde"
                type="text"
            />
          </vs-col>
          <vs-col
              class="mb-3"
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="2"
          >
            <vs-input
                v-model="parametro.carros_noite"
                class="w-full mx-4"
                color="dark"
                icon="QTD"
                icon-after="true"
                label-placeholder="Carros noite"
                type="text"
            />
          </vs-col>
          <vs-col
              class="mb-3"
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="2"
          >
            <vs-input
                v-model="parametro.carros_madrugada"
                class="w-full mx-4"
                color="dark"
                icon="QTD"
                icon-after="true"
                label-placeholder="Carros madrugada"
                type="text"
            />
          </vs-col>
        </vs-row>

        <vs-row vs-align="center" vs-justify="center" vs-type="flex" vs-w="12">
          <vs-col
              class="mb-3"
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="2"
          >
            <vs-input
                v-model="parametro.motos_manha"
                class="w-full mx-4"
                color="dark"
                icon="QTD"
                icon-after="true"
                label-placeholder="Motos manha"
                type="text"
            />
          </vs-col>
          <vs-col
              class="mb-3"
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="2"
          >
            <vs-input
                v-model="parametro.motos_almoco"
                class="w-full mx-4"
                color="dark"
                icon="QTD"
                icon-after="true"
                label-placeholder="Motos almoco"
                type="text"
            />
          </vs-col>
          <vs-col
              class="mb-3"
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="2"
          >
            <vs-input
                v-model="parametro.motos_tarde"
                class="w-full mx-4"
                color="dark"
                icon="QTD"
                icon-after="true"
                label-placeholder="Motos tarde"
                type="text"
            />
          </vs-col>
          <vs-col
              class="mb-3"
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="2"
          >
            <vs-input
                v-model="parametro.motos_noite"
                class="w-full mx-4"
                color="dark"
                icon="QTD"
                icon-after="true"
                label-placeholder="Motos noite"
                type="text"
            />
          </vs-col>
          <vs-col
              class="mb-3"
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="2"
          >
            <vs-input
                v-model="parametro.motos_madrugada"
                class="w-full mx-4"
                color="dark"
                icon="QTD"
                icon-after="true"
                label-placeholder="Motos madrugada"
                type="text"
            />
          </vs-col>
        </vs-row>
        <vs-divider border-style="dotted" class="font-bold" color="dark"
        >Selos do Relatório Técnico (Limite de 4 Selos)
        </vs-divider
        >
        <vs-row vs-justify="flex-start" vs-type="flex" vs-w="12">
          <vs-col vs-align="center" vs-justify="center" vs-type="flex" vs-w="4">
            <div class="my-10">
              <el-upload
                  :key="reRender"
                  ref="selo_1"
                  :auto-upload="false"
                  :file-list="fileListSelo1"
                  :limit="1"
                  :on-change="changeListSelos"
                  :on-exceed="exceed"
                  :on-remove="removeSelo1"
                  accept=" .jpg, .jpeg, .png, .gif"
                  action=""
                  class="w-full"
                  list-type="picture-card"
              >
                <i class="el-icon-plus" style="font-size: 18px">Selo 1</i>
              </el-upload>
            </div>
          </vs-col>
          <vs-col vs-align="center" vs-justify="center" vs-type="flex" vs-w="4">
            <div class="my-10">
              <el-upload
                  :key="reRender"
                  ref="selo_2"
                  :auto-upload="false"
                  :file-list="fileListSelo2"
                  :limit="1"
                  :on-change="changeListSelos"
                  :on-exceed="exceed"
                  :on-remove="removeSelo2"
                  accept=" .jpg, .jpeg, .png, .gif"
                  action=""
                  class="w-full"
                  list-type="picture-card"
              >
                <i class="el-icon-plus" style="font-size: 18px">Selo 2</i>
              </el-upload>
            </div>
          </vs-col>
          <vs-col vs-align="center" vs-justify="center" vs-type="flex" vs-w="4">
            <div class="my-10">
              <el-upload
                  :key="reRender"
                  ref="selo_3"
                  :auto-upload="false"
                  :file-list="fileListSelo3"
                  :limit="1"
                  :on-change="changeListSelos"
                  :on-exceed="exceed"
                  :on-remove="removeSelo3"
                  accept=" .jpg, .jpeg, .png, .gif"
                  action=""
                  class="w-full"
                  list-type="picture-card"
              >
                <i class="el-icon-plus" style="font-size: 18px">Selo 3</i>
              </el-upload>
            </div>
          </vs-col>
          <vs-col vs-align="center" vs-justify="center" vs-type="flex" vs-w="4">
            <div class="my-10">
              <el-upload
                  :key="reRender"
                  ref="selo_4"
                  :auto-upload="false"
                  :file-list="fileListSelo4"
                  :limit="1"
                  :on-change="changeListSelos"
                  :on-exceed="exceed"
                  :on-remove="removeSelo4"
                  accept=" .jpg, .jpeg, .png, .gif"
                  action=""
                  class="w-full"
                  list-type="picture-card"
              >
                <i class="el-icon-plus" style="font-size: 18px">Selo 4</i>
              </el-upload>
            </div>
          </vs-col>
        </vs-row>
        <vs-divider border-style="dotted" class="font-bold" color="dark"
        >Selos do Cerficado de Serviços (Limite de 4 Selos)
        </vs-divider
        >
        <vs-row vs-justify="flex-start" vs-type="flex" vs-w="12">
          <vs-col vs-align="center" vs-justify="center" vs-type="flex" vs-w="4">
            <div class="my-10">
              <el-upload
                  :key="reRender"
                  ref="selo_certificado_1"
                  :auto-upload="false"
                  :file-list="fileListSeloCerficado1"
                  :limit="1"
                  :on-change="changeListSelosCerficado"
                  :on-exceed="exceed"
                  :on-remove="removeSeloCerficado1"
                  accept=" .jpg, .jpeg, .png, .gif"
                  action=""
                  class="w-full"
                  list-type="picture-card"
              >
                <i class="el-icon-plus" style="font-size: 18px"
                >Selo Cerficado 1</i
                >
              </el-upload>
            </div>
          </vs-col>
          <vs-col vs-align="center" vs-justify="center" vs-type="flex" vs-w="4">
            <div class="my-10">
              <el-upload
                  :key="reRender"
                  ref="selo_certificado_2"
                  :auto-upload="false"
                  :file-list="fileListSeloCerficado2"
                  :limit="1"
                  :on-change="changeListSelosCerficado"
                  :on-exceed="exceed"
                  :on-remove="removeSeloCerficado2"
                  accept=" .jpg, .jpeg, .png, .gif"
                  action=""
                  class="w-full"
                  list-type="picture-card"
              >
                <i class="el-icon-plus" style="font-size: 18px"
                >Selo Cerficado 2</i
                >
              </el-upload>
            </div>
          </vs-col>
          <vs-col vs-align="center" vs-justify="center" vs-type="flex" vs-w="4">
            <div class="my-10">
              <el-upload
                  :key="reRender"
                  ref="selo_certificado_3"
                  :auto-upload="false"
                  :file-list="fileListSeloCerficado3"
                  :limit="1"
                  :on-change="changeListSelosCerficado"
                  :on-exceed="exceed"
                  :on-remove="removeSeloCerficado3"
                  accept=" .jpg, .jpeg, .png, .gif"
                  action=""
                  class="w-full"
                  list-type="picture-card"
              >
                <i class="el-icon-plus" style="font-size: 18px"
                >Selo Cerficado 3</i
                >
              </el-upload>
            </div>
          </vs-col>
          <vs-col vs-align="center" vs-justify="center" vs-type="flex" vs-w="4">
            <div class="my-10">
              <el-upload
                  :key="reRender"
                  ref="selo_certificado_4"
                  :auto-upload="false"
                  :file-list="fileListSeloCerficado4"
                  :limit="1"
                  :on-change="changeListSelosCerficado"
                  :on-exceed="exceed"
                  :on-remove="removeSeloCerficado4"
                  accept=" .jpg, .jpeg, .png, .gif"
                  action=""
                  class="w-full"
                  list-type="picture-card"
              >
                <i class="el-icon-plus" style="font-size: 18px"
                >Selo Cerficado 4</i
                >
              </el-upload>
            </div>
          </vs-col>
        </vs-row>
        <vs-divider border-style="dotted" class="font-bold" color="dark"
        >Imagem do Background (Limite de 1 Background)
        </vs-divider
        >
        <vs-row vs-justify="flex-start" vs-type="flex" vs-w="12">
          <vs-col
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="12"
          >
            <div class="my-10">
              <el-upload
                  :key="reRender"
                  ref="background"
                  :auto-upload="false"
                  :file-list="backgroundList"
                  :limit="1"
                  :on-change="changeListBackground"
                  :on-exceed="exceed"
                  :on-remove="deleteBackground"
                  accept=" .jpg, .jpeg, .png, .gif"
                  action=""
                  class="w-full"
                  list-type="picture-card"
              >
                <i class="el-icon-plus" style="font-size: 18px">Background</i>
              </el-upload>
            </div>
          </vs-col>
        </vs-row>
        <vs-divider border-style="dotted" class="font-bold" color="dark"
        >Assinatura do Engenheiro Químico (Limite de 1 Imagem)
        </vs-divider
        >
        <vs-row vs-justify="flex-start" vs-type="flex" vs-w="12">
          <vs-col
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="12"
          >
            <div class="my-10">
              <el-upload
                  :key="reRender"
                  ref="assinaturaEngQuim"
                  :auto-upload="false"
                  :file-list="assinaturaEngQuimList"
                  :limit="1"
                  :on-change="changeListAssinaturaEngQuim"
                  :on-exceed="exceed"
                  :on-remove="deleteAssinaturaEngQuim"
                  accept=" .jpg, .jpeg, .png, .gif"
                  action=""
                  class="w-full"
                  list-type="picture-card"
              >
                <i class="el-icon-plus" style="font-size: 18px">Assinatura</i>
              </el-upload>
            </div>
          </vs-col>
        </vs-row>
      </div>
    </VuePerfectScrollbar>
    </vs-tab>

    <vs-tab label="Variáveis de Sistema">
      <!-- v-if evita a chamada a API enquanto a aba estiver fechada e
           recarrega a listagem a cada vez que ela e aberta -->
      <div v-if="abaAtiva === 1" class="mt-5">
        <ListaConfiguracaoSistema/>
      </div>
    </vs-tab>

    <vs-tab label="Parametrização Fiscal IBS/CBS">
      <div v-if="abaAtiva === 2" class="mt-5">
        <ListaFiscalIbsCbs/>
      </div>
    </vs-tab>
    </vs-tabs>

    <!-- Modal de Inspeção de Variáveis de Template WATI e Relações SQL -->
    <vs-popup
      class="modal-inspecao-template-wati"
      size="large"
      title="Dicionário de Variáveis do Template WATI & Mapeamento SQL (SCORPIO ERP)"
      :active.sync="modalDetalhesTemplate"
      style="z-index: 300000;"
    >
      <div class="p-4" style="max-height: 80vh; overflow-y: auto;">
        <!-- Seletor de Template para Inspecionar -->
        <div class="mb-4 p-3 rounded flex flex-wrap items-center justify-between" style="border: 1px solid #cbd5e1; background: #f8fafc;">
          <div class="w-full sm:w-1/2 pr-2 mb-2 sm:mb-0">
            <label class="text-xs font-semibold block mb-1" style="color: #0f172a;">Selecione o Template WATI para Inspecionar:</label>
            <el-select
              v-model="templateSelecionadoParaInspecao"
              filterable
              popper-class="popper-select-template"
              class="w-full"
              placeholder="Escolha um template aprovado"
              @change="onTrocarTemplateInspecao"
            >
              <el-option
                v-for="tpl in listaTemplatesWati"
                :key="tpl.elementName || tpl"
                :label="tpl.elementName || tpl"
                :value="tpl.elementName || tpl"
              />
            </el-select>
          </div>
          <div class="w-full sm:w-1/2 flex items-center justify-start sm:justify-end gap-2" v-if="templateAtualObjeto">
            <span class="inline-block px-2 py-1 text-xs font-semibold rounded" style="background-color: #d1fae5; color: #064e3b; border: 1px solid #059669;">
              Status: {{ templateAtualObjeto.status || 'APPROVED' }}
            </span>
            <span class="inline-block px-2 py-1 text-xs font-semibold rounded" style="background-color: #e0e7ff; color: #312e81; border: 1px solid #6366f1;" v-if="templateAtualObjeto.category">
              Categoria: {{ templateAtualObjeto.category }}
            </span>
          </div>
        </div>

        <div v-if="templateAtualObjeto">
          <!-- Bloco 1: Visualização do WhatsApp e Botões -->
          <div class="mb-5">
            <h5 class="text-sm font-bold mb-2 flex items-center" style="color: #0f172a;">
              <vs-icon icon="chat" size="small" class="mr-1" style="color: #059669;" />
              Pré-visualização do Template WhatsApp (Variáveis Destacadas)
            </h5>
            <div
              class="p-4 rounded-lg shadow-sm"
              style="background-color: #efeae2; border: 1px solid #d1d7db; max-width: 600px; margin: 0 auto;"
            >
              <!-- Balão de Mensagem WhatsApp -->
              <div
                class="p-3 rounded-lg text-sm"
                style="background-color: #ffffff; color: #111b21; border-radius: 8px; box-shadow: 0 1px 0.5px rgba(11,20,26,.13); line-height: 1.5; white-space: pre-wrap;"
                v-html="formatarPreviewMensagem(templateAtualObjeto.bodyOriginal || templateAtualObjeto.body || '')"
              ></div>

              <!-- Botões do Template se houver -->
              <div
                v-if="templateAtualObjeto.buttons && templateAtualObjeto.buttons.length"
                class="mt-2 flex flex-col gap-1"
                style="display: flex; flex-direction: column; gap: 4px;"
              >
                <div
                  v-for="(btn, bIdx) in templateAtualObjeto.buttons"
                  :key="bIdx"
                  class="py-2 text-center text-xs font-semibold bg-white rounded cursor-default border shadow-sm"
                  style="border-color: #94a3b8; color: #1e40af;"
                >
                  <vs-icon icon="reply" size="small" class="mr-1" style="font-size: 13px;" />
                  {{ btn.text }}
                </div>
              </div>
            </div>
          </div>

          <!-- Bloco 2: Tabela de Dicionário de Variáveis & Mapeamento SQL -->
          <div class="mb-5">
            <h5 class="text-sm font-bold mb-1 flex items-center" style="color: #0f172a;">
              <vs-icon icon="storage" size="small" class="mr-1" style="color: #2563eb;" />
              Mapeamento de Variáveis vs. Banco de Dados SQL (SCORPIO)
            </h5>
            <p class="text-xs mb-2" style="color: #334155; font-weight: 500;">
              Confira como cada variável informada no template é lida nas tabelas do sistema durante o disparo e como a confirmação é gravada após o retorno do Webhook:
            </p>

            <div v-if="variaveisTemplateInspecao && variaveisTemplateInspecao.length">
              <div class="overflow-x-auto" style="border: 1px solid #cbd5e1; border-radius: 6px;">
                <table class="w-full text-left border-collapse" style="font-size: 12px; width: 100%;">
                  <thead>
                    <tr style="background-color: #f1f5f9; border-bottom: 2px solid #94a3b8;">
                      <th class="p-2 font-semibold" style="color: #0f172a;">Variável WATI</th>
                      <th class="p-2 font-semibold" style="color: #0f172a;">Origem no Envio (SQL)</th>
                      <th class="p-2 font-semibold" style="color: #0f172a;">Destino no Webhook (Gravação)</th>
                      <th class="p-2 font-semibold text-center" style="color: #0f172a;">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, vIdx) in variaveisTemplateInspecao"
                      :key="vIdx"
                      :style="{ backgroundColor: vIdx % 2 === 0 ? '#ffffff' : '#f8fafc', borderBottom: '1px solid #e2e8f0' }"
                    >
                      <td class="p-2 font-mono font-bold" style="vertical-align: top; color: #1e3a8a;">
                        <span v-text="'{{' + item.nomeVariavel + '}}'"></span>
                        <div class="font-sans font-medium text-xs mt-1" style="color: #475569;" v-if="item.label">
                          {{ item.label }}
                        </div>
                      </td>
                      <td class="p-2" style="vertical-align: top;">
                        <div class="font-bold" style="color: #0f172a;">
                          <code style="color: #0f172a; background: #e2e8f0; padding: 2px 4px; border-radius: 3px;">{{ item.tabelaOrigem }}</code> <span v-if="item.colunaOrigem !== '-'">➔ <code style="color: #0f172a; background: #e2e8f0; padding: 2px 4px; border-radius: 3px;">{{ item.colunaOrigem }}</code></span>
                        </div>
                        <div class="text-xs mt-1" style="color: #334155; font-weight: 500;">
                          {{ item.descricaoEnvio }}
                        </div>
                      </td>
                      <td class="p-2" style="vertical-align: top;">
                        <div class="text-xs" style="color: #334155; font-weight: 500;">
                          {{ item.gravacaoWebhook }}
                        </div>
                      </td>
                      <td class="p-2 text-center" style="vertical-align: top;">
                        <span
                          v-if="item.suportado"
                          class="inline-block px-2 py-1 rounded text-xs font-semibold"
                          style="background-color: #d1fae5; color: #064e3b; border: 1px solid #059669;"
                        >
                          ✅ Mapeado no Sistema
                        </span>
                        <span
                          v-else
                          class="inline-block px-2 py-1 rounded text-xs font-semibold"
                          style="background-color: #fef3c7; color: #78350f; border: 1px solid #d97706;"
                        >
                          ⚠️ Sem Mapeamento Direto
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-else class="p-3 rounded text-xs" style="background-color: #fef3c7; color: #78350f; border: 1px solid #d97706;">
              Nenhuma variável dinâmica identificada neste template (mensagem puramente estática).
            </div>
          </div>

          <!-- Bloco 3: Explicação do Ciclo de Vida do Dado no Banco -->
          <div class="p-4 rounded-lg" style="background: #f0fdf4; border: 1px solid #86efac;">
            <h6 class="font-bold mb-2 flex items-center" style="color: #14532d; font-size: 13px;">
              <vs-icon icon="info" size="small" class="mr-1" />
              Como a informação é guardada no nosso banco de dados:
            </h6>
            <div class="text-xs space-y-2" style="line-height: 1.6; color: #166534;">
              <p>
                <strong style="color: #14532d;">1. No Momento do Envio:</strong> O SCORPIO carrega os dados das tabelas relacionadas (<code style="background-color: #dcfce7; color: #052e16; border: 1px solid #86efac; font-weight: 600; padding: 1px 4px; border-radius: 3px;">os</code>, <code style="background-color: #dcfce7; color: #052e16; border: 1px solid #86efac; font-weight: 600; padding: 1px 4px; border-radius: 3px;">clientes</code>, <code style="background-color: #dcfce7; color: #052e16; border: 1px solid #86efac; font-weight: 600; padding: 1px 4px; border-radius: 3px;">controles</code>, <code style="background-color: #dcfce7; color: #052e16; border: 1px solid #86efac; font-weight: 600; padding: 1px 4px; border-radius: 3px;">enderecos</code>), preenche os parâmetros e dispara a mensagem via WATI. Um registro de rastreio é criado na tabela <code style="background-color: #dcfce7; color: #052e16; border: 1px solid #86efac; font-weight: 600; padding: 1px 4px; border-radius: 3px;">os_confirmacao_whatsapp</code> com <code>id_os</code>, <code>telefone</code>, <code>id_mensagem_wati</code> e <code>confirmado = 0</code>.
              </p>
              <p>
                <strong style="color: #14532d;">2. No Retorno do Webhook (Resposta do Cliente):</strong> Quando o cliente clica no botão "Confirmar" ou responde confirmando, a WATI notifica nossa API (<code>/webhookConfirmacaoWati</code>). O sistema vincula o retorno pelo <code>id_mensagem_wati</code> ou pelo telefone do contato, atualizando:
              </p>
              <ul class="list-disc list-inside pl-2 text-xs" style="margin-left: 8px; color: #166534;">
                <li><code style="background-color: #dcfce7; color: #052e16; border: 1px solid #86efac; font-weight: 600; padding: 1px 4px; border-radius: 3px;">os_confirmacao_whatsapp.confirmado = 1</code> (marca como confirmado no log de mensagens)</li>
                <li><code style="background-color: #dcfce7; color: #052e16; border: 1px solid #86efac; font-weight: 600; padding: 1px 4px; border-radius: 3px;">os.confirmado = 1</code> (marca a própria Ordem de Serviço como confirmada na agenda)</li>
                <li><code style="background-color: #dcfce7; color: #052e16; border: 1px solid #86efac; font-weight: 600; padding: 1px 4px; border-radius: 3px;">os.pessoa_confirmacao = 'Cliente via WhatsApp'</code> e <code>os.data_execucao = CURRENT_TIMESTAMP</code></li>
              </ul>
              <p class="mt-2" style="color: #15803d;">
                <em>* Caso o cliente clique em "Reagendar", a mensagem de solicitação é salva no log e a OS permanece pendente para contato da equipe operacional.</em>
              </p>
            </div>
          </div>
        </div>

        <div v-else class="text-center p-8" style="color: #475569;">
          <vs-icon icon="search" size="large" class="mb-2" />
          <p>Nenhum template selecionado ou template não localizado na lista de aprovados do WATI.</p>
        </div>

        <!-- Botão de Fechar no Rodapé -->
        <div class="mt-4 pt-3 flex justify-end" style="border-top: 1px solid #cbd5e1;">
          <button
            type="button"
            class="btn-fechar-modal-a11y"
            aria-label="Fechar modal de inspeção de templates WATI"
            @click="modalDetalhesTemplate = false"
          >
            Fechar
          </button>
        </div>
      </div>
    </vs-popup>
  </vx-card>
</template>

<script>
import components from "@/components/default/exports.js";
import ListaConfiguracaoSistema from "./components/configuracaoSistema/lista.vue";
import ListaFiscalIbsCbs from "./components/fiscalIbsCbs/lista.vue";
import { extrairVariaveisTemplate } from "@/constants/watiVariableMappings.js";

export default {
  data() {
    return {
      abaAtiva: 0,
      email: [],
      parametro: {},
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.8
      },
      reRender: 0,
      blockButton: false,
      provedoresWhatsapp: [
        {text: "WATI", value: "WATI"},
        {text: "Evolution API", value: "EVOLUTION"}
      ],
      templatesConfirmacaoOs: [],
      templatesPco: [],
      templatesPosVenda: [],
      templatesCobranca: [],
      listaTemplatesWati: [],
      modalDetalhesTemplate: false,
      templateSelecionadoParaInspecao: "",
      moduloInspecaoAtual: "confirmacao",
      //variaveis dos selos
      file: {},
      dialogVisible: false,
      dialogImageUrl: null,
      changeSelos: false,
      fileListSelo1: [],
      fileListSelo2: [],
      fileListSelo3: [],
      fileListSelo4: [],
      //variaveis dos selos certificado
      changeSelosCerficado: false,
      fileListSeloCerficado1: [],
      fileListSeloCerficado2: [],
      fileListSeloCerficado3: [],
      fileListSeloCerficado4: [],
      //variaveis do background
      dialogVisibleBackground: false,
      dialogImageUrlBackground: null,
      backgroundList: [],
      changeBackground: false,
      //assinatura eng quim
      assinaturaEngQuimList: [],
      changeAssinaturaEngQuim: false,
    };
  },
  computed: {
    templateAtualObjeto() {
      if (!this.templateSelecionadoParaInspecao) {
        return null;
      }
      const nomeAlvo = String(this.templateSelecionadoParaInspecao).trim().toLowerCase();
      if (this.listaTemplatesWati && this.listaTemplatesWati.length) {
        for (let i = 0; i < this.listaTemplatesWati.length; i++) {
          const tpl = this.listaTemplatesWati[i];
          const nomeTpl = (tpl && (tpl.elementName || tpl)) ? String(tpl.elementName || tpl).trim().toLowerCase() : "";
          if (nomeTpl === nomeAlvo) {
            return tpl;
          }
        }
      }
      // Fallback gracioso com variáveis padrão reconhecidas pelo SCORPIO
      return {
        elementName: this.templateSelecionadoParaInspecao,
        status: "APPROVED",
        category: "UTILITY",
        bodyOriginal: "Olá {{nome}}, confirmamos sua OS {{os_cliente}} agendada para {{data}} às {{hora}} no endereço {{local}} para o serviço {{servico}}.",
        customParams: [
          { paramName: "nome", paramValue: "Exemplo Cliente" },
          { paramName: "os_cliente", paramValue: "516409" },
          { paramName: "servico", paramValue: "Controle de Pragas" },
          { paramName: "data", paramValue: "04/10/2026" },
          { paramName: "hora", paramValue: "09:00" },
          { paramName: "local", paramValue: "Rua Exemplo, 123" }
        ],
        buttons: [
          { text: "Confirmar Serviço", type: "QUICK_REPLY" },
          { text: "Reagendar", type: "QUICK_REPLY" }
        ]
      };
    },
    variaveisTemplateInspecao() {
      if (!this.templateAtualObjeto) {
        return [];
      }
      return extrairVariaveisTemplate(this.templateAtualObjeto, this.moduloInspecaoAtual || "confirmacao");
    }
  },
  methods: {
    abrirModalDetalhesTemplate(tplNome, modulo) {
      this.moduloInspecaoAtual = modulo || "confirmacao";
      if (tplNome) {
        this.templateSelecionadoParaInspecao = tplNome;
      } else if (this.listaTemplatesWati && this.listaTemplatesWati.length) {
        const primeiro = this.listaTemplatesWati[0];
        this.templateSelecionadoParaInspecao = (primeiro && primeiro.elementName) ? primeiro.elementName : primeiro;
      } else if (this.templatesConfirmacaoOs && this.templatesConfirmacaoOs.length) {
        this.templateSelecionadoParaInspecao = this.templatesConfirmacaoOs[0];
      } else {
        this.templateSelecionadoParaInspecao = "confirmacao_ultima_chamada";
      }
      this.modalDetalhesTemplate = true;
    },
    onTrocarTemplateInspecao(val) {
      this.templateSelecionadoParaInspecao = val;
    },
    formatarPreviewMensagem(body) {
      if (!body) return "";
      let escaped = String(body)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
      escaped = escaped.replace(/\{\{([a-zA-Z0-9_\-]+)\}\}/g, '<span style="background-color: #dbeafe; color: #1e40af; font-weight: bold; padding: 2px 4px; border-radius: 4px; border: 1px solid #bfdbfe;">{{$1}}</span>');
      escaped = escaped.replace(/\n/g, "<br/>");
      return escaped;
    },
    getPhoneMask(val) {
      const numbers = (val || '').replace(/\D/g, '');
      return numbers.length <= 10 ? '(##) ####-####' : '(##) #####-####';
    },
    parseTemplatesWati(val) {
      if (!val) return [];
      if (Array.isArray(val)) return val;
      try {
        const parsed = JSON.parse(val);
        if (Array.isArray(parsed)) return parsed;
      } catch (e) {
        // Fallback para string separada por vírgula
      }
      return String(val).split(',').map(s => s.trim()).filter(Boolean);
    },
    async carregarTemplatesWatiAprovados() {
      try {
        const res = await this.$http.get("getWatiTemplates?filtro[status][]=approved");
        let lista = [];
        if (res && res.data) {
          lista = res.data.data ? res.data.data : (Array.isArray(res.data) ? res.data : (res.data.messageTemplates || []));
        }
        this.listaTemplatesWati = Array.isArray(lista) ? lista : [];
      } catch (e) {
        console.error("Erro ao carregar lista de templates WATI:", e);
      }
    },
    //Funcoes Globais
    async getParametros() {
      await this.$vs.loading({
        container: "#parametros",
        scale: 0.6
      });
      this.blockButton = true;
      try {
        this.parametro = await this.$http.get(`parametro/1`);
        this.templatesConfirmacaoOs = this.parseTemplatesWati(this.parametro.wati_templates_confirmacao_os);
        this.templatesPco = this.parseTemplatesWati(this.parametro.wati_templates_pco);
        this.templatesPosVenda = this.parseTemplatesWati(this.parametro.wati_templates_pos_venda);
        this.templatesCobranca = this.parseTemplatesWati(this.parametro.wati_templates_cobranca);
        await this.carregarTemplatesWatiAprovados();
        await this.mountObjImageSelos();
        await this.mountObjImageSelosCerficado();
        await this.mountObjImageBackground();
        await this.mountObjAssinaturaEngQuim();
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
        ;
      } finally {
        this.blockButton = await false;
        this.reRender += await 1;
        await this.$vs.loading.close("#parametros > .con-vs-loading");
      }
    },
    async update() {
      await this.$vs.loading({
        container: "#parametros",
        scale: 0.6
      });
      this.blockButton = true;
      try {
        this.parametro.wati_templates_confirmacao_os = JSON.stringify(this.templatesConfirmacaoOs || []);
        this.parametro.wati_templates_pco = JSON.stringify(this.templatesPco || []);
        this.parametro.wati_templates_pos_venda = JSON.stringify(this.templatesPosVenda || []);
        this.parametro.wati_templates_cobranca = JSON.stringify(this.templatesCobranca || []);
        await this.$http.put(`parametro/1`, this.parametro);
        if (this.changeSelos) {
          await this.uploadImagensSelos();
        }
        if (this.changeSelosCerficado) {
          await this.uploadImagensSelosCerficado();
        }
        if (this.changeAssinaturaEngQuim) {
          await this.uploadAssinaturaEngQuim();
        }
        if (this.changeBackground) {
          await this.uploadImagemBackground();
        }
        let logData = {
          id_colaborador: localStorage.getItem("id"),
          funcao: "atualizar",
          setor: "comercial",
          ip: window.localStorage.getItem("ip"),
          texto: "Atualização dos parâmetros "
        };
        await this.$logger(logData);
        await this.success();
        this.reRender++;
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
        ;
      } finally {
        this.blockButton = false;
        await this.$vs.loading.close("#parametros > .con-vs-loading");
        await this.getParametros();
      }
    },
    async success() {
      this.$vs.notify({
        title: "Sucesso",
        text: "Parâmetros Atualizados com Sucesso!",
        color: "success"
      });
    },
    async exceed() {
      this.$vs.notify({
        title: "Tenha Calma!",
        text: "Limite de 1 Imagen!",
        color: "danger"
      });
    },
    //Funcoes da Assiantura do Eng Quimico
    async deleteAssinaturaEngQuim() {
      await this.$vs.loading({
        container: "#parametros",
        scale: 0.6
      });
      this.blockButton = true;
      try {
        this.parametro = await this.$http.delete(`deleteAssinaturaEngQuim`);
        await this.success();
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
        ;
      } finally {
        await this.$vs.loading.close("#parametros > .con-vs-loading");
        await this.getParametros();
        this.reRender += await 1;
        this.blockButton = false;
      }
    },
    async mountObjAssinaturaEngQuim() {
      let file = null;
      file = this.parametro.assinatura_engenheiro_quimico;
      this.assinaturaEngQuimList = [];
      if (file) {
        this.assinaturaEngQuimList.push({
          name: file,
          url: `${this.parametro.storage_cdn_url}/${file}`,
          status: "success"
        });
        this.reRender++;
      }
    },
    async uploadAssinaturaEngQuim() {
      try {
        let file = this.$refs.assinaturaEngQuim.uploadFiles;
        let formData = new FormData();
        await formData.append("image", file[0].raw);
        await this.$http.post(`uploadAssinaturaEngQuim`, formData);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
        ;
      } finally {
        this.changeAssinaturaEngQuim = false;
      }
    },
    //Funcoes dos Selos
    async uploadImagensSelos() {
      try {
        let file1 = await this.$refs.selo_1.uploadFiles;
        let file2 = await this.$refs.selo_2.uploadFiles;
        let file3 = await this.$refs.selo_3.uploadFiles;
        let file4 = await this.$refs.selo_4.uploadFiles;
        let formData = new FormData();
        if (file1.length > 0) {
          if (file1[0].raw != undefined) {
            await formData.append("image", file1[0].raw);
            await this.$http.post("uploadImagemSelo/1", formData);
          }
        }
        if (file2.length > 0) {
          if (file2[0].raw != undefined) {
            await formData.append("image", file2[0].raw);
            await this.$http.post("uploadImagemSelo/2", formData);
          }
        }
        if (file3.length > 0) {
          if (file3[0].raw != undefined) {
            await formData.append("image", file3[0].raw);
            await this.$http.post("uploadImagemSelo/3", formData);
          }
        }
        if (file4.length > 0) {
          if (file4[0].raw != undefined) {
            await formData.append("image", file4[0].raw);
            await this.$http.post("uploadImagemSelo/4", formData);
          }
        }
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
        ;
      } finally {
        this.changeSelos = await false;
      }
    },
    async mountObjImageSelos() {
      this.fileListSelo1 = await [];
      this.fileListSelo2 = await [];
      this.fileListSelo3 = await [];
      this.fileListSelo4 = await [];
      let file1 = this.parametro[`selo_relatorio_tecnico1`];
      let file2 = this.parametro[`selo_relatorio_tecnico2`];
      let file3 = this.parametro[`selo_relatorio_tecnico3`];
      let file4 = this.parametro[`selo_relatorio_tecnico4`];
      if (file1) {
        this.fileListSelo1.push({
          name: file1,
          url: `${this.parametro.storage_cdn_url}/${file1}`,
          status: "success"
        });
      }
      if (file2) {
        this.fileListSelo2.push({
          name: file2,
          url: `${this.parametro.storage_cdn_url}/${file2}`,
          status: "success"
        });
      }
      if (file3) {
        this.fileListSelo3.push({
          name: file3,
          url: `${this.parametro.storage_cdn_url}/${file3}`,
          status: "success"
        });
      }
      if (file4) {
        this.fileListSelo4.push({
          name: file4,
          url: `${this.parametro.storage_cdn_url}/${file4}`,
          status: "success"
        });
      }
      this.reRender++;
    },
    async removeSelo1(file) {
      await this.deleteImagemSelo("selo_relatorio_tecnico1");
    },
    async removeSelo2(file) {
      await this.deleteImagemSelo("selo_relatorio_tecnico2");
    },
    async removeSelo3(file) {
      await this.deleteImagemSelo("selo_relatorio_tecnico3");
    },
    async removeSelo4(file) {
      await this.deleteImagemSelo("selo_relatorio_tecnico4");
    },
    async deleteImagemSelo(campo) {
      await this.$vs.loading({
        container: "#parametros",
        scale: 0.6
      });
      this.blockButton = true;
      try {
        await this.$http.post(`deleteImagemSelo`, {campo: campo});
        await this.success();
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
        ;
      } finally {
        await this.$vs.loading.close("#parametros > .con-vs-loading");
        await this.getParametros();
        this.reRender += await 1;
        this.blockButton = false;
      }
    },
    //Funcoes dos Selos Certificado
    async uploadImagensSelosCerficado() {
      try {
        let file1 = await this.$refs.selo_certificado_1.uploadFiles;
        let file2 = await this.$refs.selo_certificado_2.uploadFiles;
        let file3 = await this.$refs.selo_certificado_3.uploadFiles;
        let file4 = await this.$refs.selo_certificado_4.uploadFiles;

        let formData = new FormData();
        if (file1.length > 0) {
          if (file1[0].raw != undefined) {
            await formData.append("image", file1[0].raw);
            await this.$http.post("uploadImagemSeloCertificado/1", formData);
          }
        }
        if (file2.length > 0) {
          if (file2[0].raw != undefined) {
            await formData.append("image", file2[0].raw);
            await this.$http.post("uploadImagemSeloCertificado/2", formData);
          }
        }
        if (file3.length > 0) {
          if (file3[0].raw != undefined) {
            await formData.append("image", file3[0].raw);
            await this.$http.post("uploadImagemSeloCertificado/3", formData);
          }
        }
        if (file4.length > 0) {
          if (file4[0].raw != undefined) {
            await formData.append("image", file4[0].raw);
            await this.$http.post("uploadImagemSeloCertificado/4", formData);
          }
        }
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
        ;
      } finally {
        this.changeSelosCerficado = await false;
      }
    },
    async mountObjImageSelosCerficado() {
      this.fileListSeloCerficado1 = await [];
      this.fileListSeloCerficado2 = await [];
      this.fileListSeloCerficado3 = await [];
      this.fileListSeloCerficado4 = await [];
      let file1 = this.parametro[`selo_certificado1`];
      let file2 = this.parametro[`selo_certificado2`];
      let file3 = this.parametro[`selo_certificado3`];
      let file4 = this.parametro[`selo_certificado4`];
      if (file1) {
        this.fileListSeloCerficado1.push({
          name: file1,
          url: `${this.parametro.storage_cdn_url}/${file1}`,
          status: "success"
        });
      }
      if (file2) {
        this.fileListSeloCerficado2.push({
          name: file2,
          url: `${this.parametro.storage_cdn_url}/${file2}`,
          status: "success"
        });
      }
      if (file3) {
        this.fileListSeloCerficado3.push({
          name: file3,
          url: `${this.parametro.storage_cdn_url}/${file3}`,
          status: "success"
        });
      }
      if (file4) {
        this.fileListSeloCerficado4.push({
          name: file4,
          url: `${this.parametro.storage_cdn_url}/${file4}`,
          status: "success"
        });
      }
      this.reRender++;
    },
    async removeSeloCerficado1(file) {
      await this.deleteImagemSeloCertificado("selo_certificado1");
    },
    async removeSeloCerficado2(file) {
      await this.deleteImagemSeloCertificado("selo_certificado2");
    },
    async removeSeloCerficado3(file) {
      await this.deleteImagemSeloCertificado("selo_certificado3");
    },
    async removeSeloCerficado4(file) {
      await this.deleteImagemSeloCertificado("selo_certificado4");
    },
    async deleteImagemSeloCertificado(campo) {
      await this.$vs.loading({
        container: "#parametros",
        scale: 0.6
      });
      this.blockButton = true;
      try {
        await this.$http.post(`deleteImagemSelo`, {campo: campo});
        await this.success();
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
        ;
      } finally {
        await this.$vs.loading.close("#parametros > .con-vs-loading");
        await this.getParametros();
        this.reRender += await 1;
        this.blockButton = false;
      }
    },

    //Funcoes Background
    async deleteBackground() {
      await this.$vs.loading({
        container: "#parametros",
        scale: 0.6
      });
      this.blockButton = true;
      try {
        await this.$http.delete(`deleteImageBackground`);
        await this.success();
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
        ;
      } finally {
        await this.$vs.loading.close("#parametros > .con-vs-loading");
        await this.getParametros();
        this.reRender += await 1;
        this.blockButton = false;
      }
    },
    async mountObjImageBackground() {
      let file = null;
      file = this.parametro.imagem_background;
      this.backgroundList = [];
      if (file) {
        this.backgroundList.push({
          name: file,
          url: `${this.parametro.storage_cdn_url}/${file}`,
          status: "success"
        });
        this.reRender++;
      }
    },
    async uploadImagemBackground() {
      try {
        let file = this.$refs.background.uploadFiles;
        let formData = new FormData();
        await formData.append("image", file[0].raw);
        await this.$http.post(`uploadImagemBackground`, formData);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
        ;
      } finally {
        this.changeBackground = false;
      }
    },
    //Change Events
    async changeListAssinaturaEngQuim() {
      this.changeAssinaturaEngQuim = true;
    },
    async changeListSelos() {
      this.changeSelos = true;
    },
    async changeListSelosCerficado() {
      this.changeSelosCerficado = true;
    },
    async changeListBackground() {
      this.changeBackground = true;
    }
  },
  components: {
    ...components,
    ListaConfiguracaoSistema,
    ListaFiscalIbsCbs
  },
  async mounted() {
    // O conteudo de <vs-tab> so entra no DOM depois que a aba fica ativa
    // (v-if interno do Vuesax), entao o container "#parametros" usado pelo
    // $vs.loading ainda nao existe neste ponto do ciclo de vida.
    await this.$nextTick();
    await this.getParametros();
  }
};
</script>

<style lang="scss" scoped>
.scroll-parametros {
  max-height: 78vh !important;
}
</style>

<style lang="scss">
.popper-select-template {
  z-index: 999999 !important;
}

.modal-inspecao-template-wati,
.modal-inspecao-template-wati.vs-component,
.con-vs-popup.modal-inspecao-template-wati {
  z-index: 300000 !important;
  .vs-popup--background {
    z-index: 300000 !important;
  }
  .vs-popup {
    z-index: 300001 !important;
    width: 950px !important;
    max-width: 95vw !important;
    margin: 0 auto !important;
  }
}

/* WCAG 2.2 Accessible Buttons & Badges (Contraste AA/AAA >= 4.5:1 e Focus Visible) */
.btn-inspecionar-wati-a11y {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background-color: #0f172a;
  color: #ffffff;
  border: 1px solid #0f172a;
  border-radius: 6px;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  min-height: 36px;
  line-height: 1;

  .btn-icon-svg {
    width: 14px;
    height: 14px;
    flex-shrink: 0;
    display: block;
    vertical-align: middle;
  }

  span {
    display: inline-block;
    line-height: 1;
  }

  &:hover {
    background-color: #1e293b;
    border-color: #1e293b;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  }

  &:focus-visible {
    outline: 3px solid #2563eb;
    outline-offset: 2px;
  }
}

.btn-fechar-modal-a11y {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #0f172a;
  color: #ffffff;
  border: 1px solid #0f172a;
  border-radius: 6px;
  padding: 8px 22px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  min-height: 38px;

  &:hover {
    background-color: #1e293b;
    border-color: #1e293b;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  }

  &:focus-visible {
    outline: 3px solid #2563eb;
    outline-offset: 2px;
  }
}

.badge-inspecao-a11y {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 3px 10px;
  font-size: 11px;
  font-weight: 600;
  border-radius: 9999px;
  border-width: 1px;
  border-style: solid;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.15s ease-in-out;
  line-height: 1;
  vertical-align: middle;

  .badge-icon-svg {
    width: 13px;
    height: 13px;
    flex-shrink: 0;
    display: block;
    vertical-align: middle;
  }

  span {
    display: inline-block;
    line-height: 1;
  }

  &:hover {
    filter: brightness(0.93);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
    transform: translateY(-1px);
  }

  &:focus-visible {
    outline: 2px solid #2563eb;
    outline-offset: 2px;
  }

  &.badge-inspecao-os {
    background-color: #fef3c7;
    border-color: #d97706;
    color: #78350f;
  }

  &.badge-inspecao-pco {
    background-color: #d1fae5;
    border-color: #059669;
    color: #064e3b;
  }

  &.badge-inspecao-pos-venda {
    background-color: #ede9fe;
    border-color: #7c3aed;
    color: #3b0764;
  }

  &.badge-inspecao-cobranca {
    background-color: #fee2e2;
    border-color: #dc2626;
    color: #7f1d1d;
  }
}
</style>
